module.exports = __webpack_public_path__ + "static/the-new-normal-requires-new-leadership-models-4d1ec286d7de15abdae4527308050e4f.png";